import { ReactSVG } from "react-svg";

import AddCaseBarchiveHeader from "./Header";
import AddCaseBarchiveList from "./List";
import AddCaseBarchiveModal from "./Modal";
import { useState } from "react";

const AddBarchive = ({
  bayganis,
  showBarchiveBox,
  barchiveBoxOpened,
  ...props
}) => {
  const [editItemBarchive, setEditItemBarchive] = useState();
  return (
    <>
      <div className="flex flex-col gap-8 rounded-2xl shadow-custom-lg border-[3px] border-white p-4 relative">
        <div className="flex w-full flex-col gap-2">
          <AddCaseBarchiveHeader
            path={props.path}
            title={props.title}
            location={props.location}
            edit={props.edit}
          />

          {bayganis.length <= 0 && !props.loading ? (
            <div className="mt-4 text-gray-500 flex items-start justify-start gap-2 mb-1">
              <ReactSVG
                src={`${process.env.PUBLIC_URL}/assets/images/icons/empty.svg`}
                className="w-5"
              />
              هنوز شماره‌ بایگانی اضافه  نشده است
            </div>
          ) : bayganis.length <= 0 && props.loading ? (
            <div className="h-10 flex items-center justify-center">
              <ReactSVG
                src={`${process.env.PUBLIC_URL}/assets/images/icons/loading-dot.svg`}
                className="w-8 text-gray-600"
              />
            </div>
          ) : (
            <AddCaseBarchiveList
              location={props.location}
              list={bayganis}
              editItemBarchive={editItemBarchive}
              setEditItemBarchive={setEditItemBarchive}
              edit={props.edit}
            />
          )}
        </div>
      </div>

      {showBarchiveBox && barchiveBoxOpened === props.location && (
        <AddCaseBarchiveModal
          showBarchiveBox={showBarchiveBox}
          location={props.location}
          editItemBarchive={editItemBarchive}
          setEditItemBarchive={setEditItemBarchive}
          edit={props.edit}
        />
      )}
    </>
  );
};

export default AddBarchive;
